var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vh-100"},[_c('sidebar'),_c('div',{staticClass:"d-flex flex-column"},[_c('navbar'),_c('keep-alive',[_c('router-view',{staticClass:"flex-fill"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }